import { EditorialModule } from '../src/EditorialModule';
export default EditorialModule;
